import { tss } from "tss-react/mui";

export const useProductCardStyles = tss.withName("ProductCard").create(({ theme }) => ({
    root: {
        display: "block",
        textDecoration: "none",
        color: "inherit",
        overflow: "hidden",
        "&:hover img": {
            transform: "scale(1.04)",
        },
    },
    imageWrapper: {
        position: "relative" as const,
        width: "100%",
        aspectRatio: "1 / 1",
        backgroundColor: theme.palette.background.paper,
        overflow: "hidden",
    },
    image: {
        width: "100%",
        height: "100%",
        objectFit: "cover" as const,
        transition: "transform 0.5s ease",
    },
    badge: {
        position: "absolute" as const,
        top: theme.spacing(1.5),
        left: theme.spacing(1.5),
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        fontSize: "0.65rem",
        fontWeight: 600,
        padding: "4px 8px",
        borderRadius: 2,
        textTransform: "uppercase" as const,
        letterSpacing: "0.08em",
    },
    wishlistButton: {
        position: "absolute" as const,
        top: theme.spacing(1),
        right: theme.spacing(1),
        backgroundColor: theme.palette.background.paper,
        borderRadius: 2,
        padding: 7,
        "&:hover": {
            backgroundColor: theme.palette.background.paper,
        },
    },
    wishlistIcon: {
        fontSize: "1.1rem",
        color: theme.palette.secondary.dark,
    },
    wishlistIconActive: {
        color: theme.palette.primary.main,
    },
    info: {
        padding: theme.spacing(2, 0, 0),
        textAlign: "left" as const,
    },
    vendor: {
        fontSize: "0.7rem",
        color: theme.palette.text.secondary,
        textTransform: "uppercase" as const,
        letterSpacing: "0.06em",
        fontWeight: 600,
        marginBottom: theme.spacing(0.5),
    },
    title: {
        fontWeight: 500,
        marginBottom: theme.spacing(1),
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical" as const,
        overflow: "hidden",
    },
    priceRow: {
        display: "flex",
        alignItems: "baseline",
        gap: theme.spacing(0.75),
        marginBottom: theme.spacing(0.5),
    },
    from: {
        fontSize: "0.75rem",
        color: theme.palette.text.secondary,
    },
    price: {
        fontFamily: "'Fira Code', monospace",
        fontWeight: 500,
        fontSize: "0.95rem",
        color: theme.palette.text.primary,
    },
    pillRow: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
        flexWrap: "wrap" as const,
        marginBottom: theme.spacing(1),
    },
    wasPill: {
        fontFamily: "'Fira Code', monospace",
        fontSize: "0.8rem",
        color: theme.palette.text.disabled,
        textDecoration: "line-through",
    },
    savePill: {
        fontSize: "0.72rem",
        fontWeight: 600,
        color: theme.palette.primary.dark,
        textTransform: "uppercase" as const,
        letterSpacing: "0.04em",
    },
    cta: {
        marginTop: theme.spacing(1.5),
        padding: "10px 16px",
        fontSize: "0.75rem",
    },
}));
